import React from 'react';
import createStore from 'redux/createStore';
import { Provider } from 'react-redux';
import ThemeProvider from 'contexts/theme';
import { BrowserRouter } from 'react-router-dom';
import Routes from 'routes';

const store = createStore();

const App = () => {
  return (
    <Provider key="provider" store={store}>
      <ThemeProvider>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
